import { TypePolicies } from "@apollo/client";

export const mapEditorTypePolicies: TypePolicies = {
    GqlMapEditorLayer: {
        fields: {
            featureCollection: {
                merge: (existing, incoming) => incoming ?? existing,
            },
        },
    },
};
